import { SelectionModel } from '@angular/cdk/collections';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';

import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { userDtos } from '@vectronic/openApi-admin';
import { CardComponent } from '@vectronic/ui';
import { CollarAndGroup } from '@vectronic/util';
import { combineLatest, Observable, startWith, Subscription } from 'rxjs';

@Component({
  selector: 'rc-add-collar-and-group',
  templateUrl: './add-collar-and-group.component.html',
  styleUrls: ['./add-collar-and-group.component.scss'],
  imports: [
    CardComponent,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatCheckbox,
    FormsModule,
    MatSelectionList,
    CdkVirtualScrollViewport,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    MatListOption,
    MatIcon,
    MatButton,
  ],
})
export class AddCollarAndGroupComponent implements OnInit, OnDestroy {
  dialogRef = inject(MatDialogRef<AddCollarAndGroupComponent>);
  data: {
    selectedCollarsAndGroups: CollarAndGroup[];
    listOfCollarAndGroup$: Observable<CollarAndGroup[]>;
  } = inject(MAT_DIALOG_DATA);

  formControl = new FormControl('');
  filteredCollarsAndGroups: CollarAndGroup[];
  selectedAll = false;
  subscription: Subscription;
  collarsAndGroupsSubscription: Subscription;
  collarsAndGroups: CollarAndGroup[];
  result: { selectedCollarsAndGroups: { group: userDtos.Group; collarId: number }[] };

  selection = new SelectionModel<number>(true);

  @ViewChild('selectionList') selectionList: MatSelectionList;

  ngOnInit() {
    const selectedCollarAndGroup = this.data.selectedCollarsAndGroups?.map(
      ({ collarId, group }) => collarId || group?.id,
    );
    if (selectedCollarAndGroup?.length) {
      this.selection.select(...selectedCollarAndGroup);
    }
    this.subscription = combineLatest([
      this.formControl.valueChanges.pipe(startWith(null)),
      this.data.listOfCollarAndGroup$,
      //this.collarAndGroupService.getListOfCollarAndGroup(),
    ]).subscribe(([value, collars]) => {
      this.selectedAll =
        Boolean(collars?.length) && this.selection?.selected?.length === collars?.length;
      this.collarsAndGroups = collars;
      if (!value) {
        this.filteredCollarsAndGroups = collars;
      } else {
        this.filteredCollarsAndGroups = collars.filter(({ collarId, group }) =>
          (collarId?.toString() || group?.name)?.includes(value),
        );
      }
    });
  }

  onSelectedAll() {
    if (this.selectedAll) {
      this.selection.select(
        ...this.filteredCollarsAndGroups.map(
          ({ collarId, group }) => (collarId?.toString() || group?.name) as any,
        ),
      );
    } else {
      this.selection.clear();
    }
  }

  onClickCollarsAndGroups() {
    const selectedCollarsAndGroups = this.selection.selected
      ?.filter((item, pos, a) => a.indexOf(item) == pos)
      ?.map((id) => {
        const group = this.collarsAndGroups.find(({ group }) => group?.id === id)?.group;
        const collarId = this.collarsAndGroups.find(({ collarId }) => collarId == id)?.collarId;
        return { group, collarId };
      });
    this.dialogRef.close({ selectedCollarsAndGroups });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.collarsAndGroupsSubscription?.unsubscribe();
  }

  isSelected(value: any) {
    return this.selection.isSelected(value);
  }

  onSelectedChange(value: any) {
    this.selection.toggle(value);
  }
}
